import angular from 'angular'
import jqueryScrollbarDirective from './jqueryScrollbarDirective'

export default angular
    .module('app.jqueryScrollbar', [])
    .directive('jqueryScrollbar', jqueryScrollbarDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/jqueryScrollbar/index.js